var EverFiRouter = Backbone.Router.extend({
  routes: {
    'resume': 'gotoFirstIncompletePage',
    ':module(/:activity)(/:page)': 'loadPage'
  },

  loadPage: function(module, activity, page) {
    if(EF.currentPage)
      EF.currentPage.unload();

    var pagePresent = page !== undefined && page !== null && page !== '';
    var activityPresent = activity !== undefined && activity !== null && activity !== '';
    var loadActivityFired = false;

    var loadPageFn = function() {
      if(pagePresent)
        EF.loadPage(page);
      else if(!loadActivityFired && EF.module.currentActivity.currentPage) {
        EF.loadPage(EF.module.currentActivity.currentPage.get('key'));
      }
    };
    var loadActivityFn = function() {
      loadActivityFired = true;
      if(activityPresent) {
        EF.loadActivity(activity, loadPageFn, pagePresent);
      }
    };

    if(!EF.module || module != EF.module.get('key')) {
      EF.setModuleByKey(module);
      EF.loadModule(loadActivityFn, activityPresent);
    } else if(!EF.module.currentActivity || activity != EF.module.currentActivity.get('key')) {
      loadActivityFn();
    } else {
      loadPageFn();
    }
  },

  gotoFirstIncompletePage: function() {
    var startModule = EF.modules.getStartingModule();
    if(startModule) {
      EF.module = startModule;
      EF.loadModule();
    }
  }

});

